import { Component, OnInit } from '@angular/core';
import { getAdminRouteByRole } from '@markant-platform/backoffice/data-access';
import { PlatformWidgetComponent } from '../platform-widget.component';
import { AuthenticatedUserService } from '@markant-platform/shared/user/data-access';
import { firstValueFrom, map } from 'rxjs';

@Component({
  selector: 'markant-platform-admin-widget',
  templateUrl: './admin-widget.component.html',
  styleUrls: ['./admin-widget.component.scss'],
})
export class AdminWidgetComponent extends PlatformWidgetComponent implements OnInit {
  link: string[] = [];

  constructor(private authenticatedUserService: AuthenticatedUserService) {
    super();
  }

  async ngOnInit(): Promise<void> {
    const roles = await firstValueFrom(
      this.authenticatedUserService.getUserRoles().pipe(map(roles => roles.map(({ name }) => name)))
    );

    this.link = getAdminRouteByRole(roles);
  }
}
